import { useQuery } from '@tanstack/react-query'
import { projectsApi } from '@/lib/api'
import type { PaginatedResponse, Project } from '@/types/api'

interface ProjectsQueryParams {
  page?: number
  page_size?: number
  status?: string
}

export function useProjects(params?: ProjectsQueryParams) {
  return useQuery<PaginatedResponse<Project>>({
    queryKey: ['projects', params?.status ?? 'all', params?.page ?? 1, params?.page_size ?? 50],
    queryFn: () => projectsApi.list(params),
    staleTime: 60_000,
  })
}
